import React from 'react';
import { motion } from 'framer-motion';

export default function KineticText({ 
  text, 
  delay = 0, 
  stagger = 0.05, 
  preset = 'rise', // 'rise' | 'pop' | 'wipe' | 'slideUp'
  className = '',
  as: Component = 'h2'
}) {
  const words = text.split(' ');

  const presets = {
    rise: {
      container: {},
      child: {
        hidden: { y: '100%', opacity: 0, rotateX: 45 },
        visible: { 
          y: 0, 
          opacity: 1, 
          rotateX: 0,
          transition: { type: 'spring', damping: 12, stiffness: 120 } 
        }
      }
    },
    pop: {
      container: {},
      child: {
        hidden: { scale: 0, opacity: 0 },
        visible: { 
          scale: 1, 
          opacity: 1,
          transition: { type: 'spring', damping: 10, stiffness: 200 } 
        }
      }
    },
    wipe: {
      container: {},
      child: {
        hidden: { clipPath: 'inset(0 100% 0 0)' },
        visible: { 
          clipPath: 'inset(0 0% 0 0)',
          transition: { duration: 0.5, ease: [0.25, 1, 0.5, 1] } 
        }
      }
    },
    slideUp: {
      container: {},
      child: {
        hidden: { y: 50, opacity: 0 },
        visible: { 
          y: 0, 
          opacity: 1,
          transition: { type: 'spring', damping: 15, stiffness: 100 } 
        }
      }
    }
  };

  const selectedPreset = presets[preset];

  return (
    <Component className={`flex flex-wrap gap-x-3 gap-y-1 overflow-hidden ${className}`}>
      {words.map((word, i) => (
        <motion.span
          key={i}
          initial="hidden"
          animate="visible"
          variants={selectedPreset.child}
          transition={{ delay: delay + (i * stagger) }}
          className="inline-block origin-bottom"
        >
          {word}
        </motion.span>
      ))}
    </Component>
  );
}
